(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-grade-visualizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hg-grade-viz')) {
    customElements.define('hg-grade-viz', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const bar = event.target.closest('[data-hg-viz]');
          if (bar) this.select(Number(bar.dataset.hgViz));
        });
      }
      select(i) {
        this.querySelectorAll('[data-hg-viz]').forEach((b, k) => {
          b.classList.toggle('is-active', k === i);
          b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        this.querySelectorAll('.hg-viz__card').forEach((c, k) => { c.hidden = k !== i; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hg-hero-slider')) {
    class HgHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.hg-hero__slide')];
        this.dots = [...this.querySelectorAll('[data-hg-dot]')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.pauseBtn = this.querySelector('[data-hg-pause]');
        this.userPaused = false;
        this.pauseBtn?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.pauseBtn.setAttribute('aria-pressed', String(this.userPaused));
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
          if (this.userPaused) this.stop(); else this.start();
        });
        this.querySelector('[data-hg-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-hg-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.hgDot), true)));

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reduce;
        if (reduce && this.pauseBtn) this.pauseBtn.hidden = true;
        this.interval = Number(this.dataset.interval) || 6000;
        ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));
        this.start();

        // Theme editor: jump to the selected slide.
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.findIndex((s) => s.contains(event.target));
          if (i > -1) { this.go(i); this.stop(); }
        });
      }

      disconnectedCallback() { this.stop(); }

      start() {
        if (!this.autoplay || this.userPaused) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }

      stop() { clearInterval(this.timer); }

      go(i, user = false) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const on = k === this.index;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
          s.querySelectorAll('a').forEach((a) => (on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        this.dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === this.index);
          if (k === this.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        if (user) this.start();
      }
    }
    customElements.define('hg-hero-slider', HgHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
